<div class="data-table" [style.width.px]="width" *ngIf="opened">

    <kendo-window *ngIf="columnSettingsDialogOpened"
                  width="600" height="700"
                  resizable="true"
                  top="-400" left="100">
        <kendo-window-titlebar>
            <div class="k-window-title">Column Settings</div>
            <button kendoWindowCloseAction title="Close" (click)="columnSettingsDialogOpened = false"></button>
        </kendo-window-titlebar>

        <div slot-ng="content" class="column-settings-dialog">
            <div class="content">
                <div class="filter">
                    <input type="text" [(ngModel)]="columnSettingsFilterText" (input)="setColumnSettingsFilteredForDialog()" placeholder="Filter by column name">
                </div>
                <div class="column-settings-list">
                    <div class="column-headers">
                        <div class="moveTop">

                        </div>
                        <div class="reorder" title="Reorder Columns">
                            <!--(click)="toggleSortColumnSettings('order')"-->
                            <!--<span>
                    <i class="icon-ui-up-down-arrows"></i>
                </span>-->
                        </div>
                        <div class="name" title="Sort By Name">
                            <!--(click)="toggleSortColumnSettings('displayName')"-->
                            Name
                        </div>
                        <div class="visibility" title="Sort By Visibility">
                            <!--(click)="toggleSortColumnSettings('visible')"-->
                            Visible
                        </div>
                        <div class="sum" title="Sort By Sum">
                            <!--(click)="toggleSortColumnSettings('calculateSum')"-->
                            Sum
                        </div>
                        <div class="average" title="Sort By Average">
                            <!--(click)="toggleSortColumnSettings('calculateAverage')"-->
                            Average
                        </div>
                    </div>
                    <div class="column-settings-list">
                        <div class="column-headers">
                            <div class="moveTop">

                            </div>
                            <div class="reorder">

                            </div>
                            <div class="name">
                            </div>
                            <div class="visibility">
                                <input type="checkbox" name='Visible' id='visible' [checked]="allVisible"
                                       (change)="selectForCheckBox('visibility', $event)">
                                <label for="Visible" style='font-size: 11px !important;'>
                                    {{ allVisible ? 'Uncheck All' : 'Check All' }}
                                </label>
                            </div>
                            <div class="sum">
                                <input type="checkbox" name='Sum' [checked]="allSum"
                                       (change)="selectForCheckBox('sum', $event)">
                                <label for="Sum" style='font-size: 11px !important;'>
                                    {{ allSum ? 'Uncheck All' : 'Check All' }}
                                </label>
                            </div>
                            <div class="average">
                                <input type="checkbox" name='Average' [checked]="allAverage"
                                       (change)="selectForCheckBox('average', $event)">
                                <label for="Average" style='font-size: 11px !important;'>
                                    {{ allAverage ? 'Uncheck All' : 'Check All' }}
                                </label>
                            </div>
                        </div>
                    </div>
                    <div cdkDropList (cdkDropListDropped)="cdkDrop($event)">
                        <div *ngFor="let columnSetting of columnSettingsFilteredForDialog; let i = index" class="column" [class.visible]="columnSetting.visible"
                             cdkDrag [cdkDragData]="columnSetting" [cdkDragBoundary]="'.content'">
                            <div *cdkDragPreview style="margin: -10px 0 0 -10px; min-width: 50px;">
                                <div class="reorder" style="display: inline-block;">
                                    <span title="Reorder" class="icon button">
                                        <i class="icon-ui-drag-horizontal"></i>
                                    </span>
                                </div>
                                <span class="name" style="text-wrap: none;">
                                    {{ columnSetting.displayName }}
                                </span>
                            </div>
                            <div class="moveTop">
                                <button title="Move to Top" class="btn btn-transparent btn-small" [disabled]="i === 0 || columnSettingsSortField !== 'order'" (click)="moveItemToTop(columnSetting)" [title]="columnSettingsSortField !== 'order' ? 'Sort by Reorder Columns to reorder' : ''">
                                    <i class="icon-ui-up-arrow"></i>
                                </button>
                            </div>
                            <div class="reorder" cdkDragHandle [class.disabled]="columnSettingsSortField !== 'order'" [title]="columnSettingsSortField !== 'order' ? 'Sort by Reorder Columns to reorder' : ''">
                                <span title="Reorder" class="icon button">
                                    <i class="icon-ui-drag-horizontal"></i>
                                </span>
                            </div>
                            <div class="name" (click)="toggleColumnVisibility(columnSetting)" [title]="columnSetting.name">
                                {{ columnSetting.displayName }}
                            </div>
                            <div class="visibility">
                                <input type="checkbox" [(ngModel)]="columnSetting.visible" (change)="columnSettingChange()">
                            </div>
                            <div class="sum">
                                <input type="checkbox" [(ngModel)]="columnSetting.calculateSum" *ngIf="columnSetting.isNumeric"
                                       (change)="columnSettingChange()">
                            </div>
                            <div class="average">
                                <input type="checkbox" [(ngModel)]="columnSetting.calculateAverage"
                                       *ngIf="columnSetting.isNumeric" (change)="columnSettingChange()">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </kendo-window>
    <div class="grid">
        <kendo-grid #grid [data]="gridDataResult" [height]="410" [resizable]="true" [rowHeight]="36"
                    [detailRowHeight]="100" [pageable]="true" [pageSize]="pageSize" [skip]="skip" scrollable="virtual"
                    [sortable]="{ allowUnsort: true, mode: 'multiple' }" [sort]="mapcoreProps.state.sort"
                    [filterable]="true" [filter]="mapcoreProps.state.filter" (dataStateChange)="dataStateChange($event)"
                    kendoGridExpandDetailsBy [expandDetailBy]="expandDetailsBy" [rowClass]="rowClass" (columnResize)="columnResized($event)"
                    [selectable]="selectableSettings" [kendoGridSelectBy]="'objectid'" [selectedKeys]="selectedObjectIds">
            <ng-template kendoGridToolbarTemplate [position]="toolbarPosition" let-position="toolbarPosition">
                <div *ngIf="enableMultiTabs" class="column-sort-order" style="padding-right:15px; border-right:2px solid white;">
                    <span class="text">Tabs:</span>
                    <select [(ngModel)]="curMultiTab" (change)="changeCurMultiTab()">
                        <option *ngFor="let option of multiTabsArr" value="{{ option.layerId }}">{{ option.name }}</option>
                    </select>
                </div>
                <div class="title">
                    <span class="text">
                        {{ mapcoreProps[titleProperty] }}
                    </span>
                </div>
                <div class="toolbar">
                    <div class="column-sort-order">
                        <span class="text">Sort Order:</span>
                        <select [(ngModel)]="columnSortOrder" (change)="changeColumnSortOrder()">
                            <option value="alphabetical">Alphabetical</option>
                            <option value="database">Database</option>
                            <option [hidden]="hideCustomSort" value="custom">Custom</option>
                        </select>
                    </div>

                    <div class="row-count-container">
                        <div class="row-count" *ngIf="!loading">
                            <span class="text">Row Count:</span>
                            <span class="value">{{ rowCount }}</span>
                            <span *ngIf="fullData.length >= defaultRecordsFetched" title="Maximum rows returned, selecting less columns or filtering the layer is recommended">?</span>
                            <!--
                    <select [(ngModel)]="selectedRecordFetch" (change)="changeRecordFetch()">
                        <option [value]="maxRecord.value" *ngFor="let maxRecord of maxRecordFetchList">
                            {{ maxRecrod.name }}
                            </option>
                        </select>
                    -->
                        </div>
                    </div>
                    <div class="loading" *ngIf="loading">
                        <span>Loading...</span>
                    </div>
                    <div class="rows-selected">
                        <span class="value" *ngIf="this.selectedObjectIds.length">
                            ({{ this.selectedObjectIds.length }})
                        </span>
                    </div>
                    <div *ngIf="recordEditorEnabled && (canUpdate || canDelete)" class="updateOrDeleteRecord clickable" [class.disabled]="selectedObjectIds.length !== 1" (click)="triggerOpenEditor(true)">
                        <span title="Edit Selected Feature" class="icon button">
                            <i class="icon-ui-edit"></i>
                        </span>
                    </div>
                    <div *ngIf="recordEditorEnabled && canInsert" class="addRecord clickable" (click)="triggerOpenEditor()">
                        <span title="Add Feature" class="icon button">
                            <i class="icon-ui-plus"></i>
                        </span>
                    </div>
                    <div class="toggle-rows-selected clickable" (click)="toggleShowSelected()"
                         [class.disabled]="selectedObjectIds.length === 0">
                        <span class="toggle-show-selected icon button" title="Toggle Show Selected">
                            <i class="icon-ui-checkbox-checked" [hidden]="!showSelected"></i>
                            <i class="icon-ui-checkbox-unchecked" [hidden]="showSelected"></i>
                        </span>
                    </div>
                    <div class="map clickable" (click)="mapSelectedFeatures()"
                         [class.disabled]="selectedObjectIds.length === 0">
                        <span title="Map Selected Features" class="icon button">
                            <i class="icon-ui-maps"></i>
                        </span>
                    </div>
                    <div class="select clickable" (click)="selectFromMap()">
                        <mc-lasso-tool-ng id="mcLassoTool" #lassoTool></mc-lasso-tool-ng>
                        <span title="Select From Map" class="icon button">
                            <i class="icon-ui-authorize"></i>
                        </span>
                    </div>
                    <div class="download clickable" (click)="download()">
                        <span title="Download Excel Spreadsheet" class="icon button">
                            <i class="icon-ui-download"></i>
                        </span>
                    </div>
                    <div class="column-options clickable" (click)="toggleColumnSettings()">
                        <span title="Column Options" class="icon button">
                            <i class="icon-ui-settings"></i>
                        </span>
                    </div>
                    <div *ngIf="!enableMultiTabs" class="close clickable" (click)="close()">
                        <span title="Close" class="icon button">
                            <i class="icon-ui-close"></i>
                        </span>
                    </div>
                    <div *ngIf="enableMultiTabs" class="close clickable">
                        <span title="Close" class="icon button" (click)="toggleCloseOptions()">
                            <i class="icon-ui-close"></i>
                        </span>
                        <div class="close-dropdown" *ngIf="showCloseOptions">
                            <a (click)="close()">Close Tab</a>
                            <a (click)="closeAll()">Close All Tabs</a>
                        </div>
                    </div>
                </div>
            </ng-template>
            <kendo-grid-checkbox-column [locked]="true" width="40" (selectionChange)="selectionChange($event)">
                <ng-template kendoGridHeaderTemplate>
                    <input type="checkbox" kendoCheckBox (change)="selectAllToggle()" [checked]="selectedObjectIds.length > 0" [indeterminate]="selectedObjectIds.length > 0 && selectedObjectIds.length !== rowCountNumber" />
                </ng-template>
            </kendo-grid-checkbox-column>
            <kendo-grid-column *ngFor="let colData of gridColumns" field="{{colData.name}}"
                               title="{{colData.displayName}}" width="{{colData.width}}" [hidden]="!colData.visible">
                <ng-template kendoGridHeaderTemplate>
                    <span [attr.title]="colData.name !== colData.displayName ? colData.name : null">{{ colData.displayName }}</span>
                </ng-template>
                <ng-template kendoGridCellTemplate let-dataItem let-column="column">
                    <span class="value" *ngIf="dataItem[column.field] != null && dataItem[column.field].domainValue" [attr.title]="dataItem[column.field].value">{{ dataItem[column.field].domainValue }}</span>
                    <span class="value" *ngIf="colData.isUrl"><a href="{{ dataItem[column.field] }}" target="_blank" rel="noopener">{{ dataItem[column.field] }}</a></span>
                    <span class="value" *ngIf="!colData.isUrl && (dataItem[column.field] != null && !dataItem[column.field].domainValue)">{{ dataItem[column.field] }}</span>
                </ng-template>
                <ng-template kendoGridFooterTemplate let-column="column" *ngIf="showFooter">
                    {{ footerText[column.field] }}
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column *ngIf="!visibleGridColumns.length" field="objectid" title="Object Id" width="100"></kendo-grid-column>
            <ng-template kendoGridDetailTemplate let-dataItem let-rowIndex="rowIndex"
                         [kendoGridDetailTemplateShowIf]="this.hasChildTables" *ngIf="this.enableAdditionalInformation">
                <mc-additional-information-ng [layerId]="this.systemLayerId" [childTables]="this.layerChildTables"
                                              [feature]="dataItem"></mc-additional-information-ng>
            </ng-template>
            <kendo-grid-messages noRecords="">
            </kendo-grid-messages>
            <kendo-grid-excel fileName="{{ mapcoreProps[titleProperty] }}.xlsx"></kendo-grid-excel>
        </kendo-grid>
    </div>
</div>
